<template>
    <div class="event-component entity-scenes">
        <div class="properties-form">
            <div v-if="eventData.gid !== null">
                <dynamic-display :load-data-api="getLoadEntityApi()" @loadEnd="onLoadEnd"
                                 :load-data-on-created="true" ref="dynamicDisplay" class="dynamic-display">
                    <template v-slot:showResultsContainer>
                        <div v-if="entityDetail">
                            <div class="card">
                                <div class="card-header">
                                    <h1>{{ entityDetail.nameEn }} {{ entityDetail.nameCh }}</h1>
                                    <div>
                                        <a href="#" @click.prevent="reviewPerson(eventData.gid)">Review</a>
                                        <span> | </span>
                                        <a href="#" @click.prevent="reviewPerson(eventData.gid, true)">Auto-Add</a>
                                    </div>
                                </div>
                                <div>
                                    <span v-if="entityDetail.gender">{{ entityDetail.gender }}</span>
                                    <span v-if="entityDetail.gender&&entityDetail.birthday">, </span>
                                    <span v-if="entityDetail.birthday">Born {{ entityDetail.birthday }}</span>
                                    <span class="text-gray"> (ID: {{ eventData.gid }})</span>
                                </div>
                                <div class="sections">
                                    <div class="section">
                                        <div class="section-header">
                                            Capacity Codes
                                        </div>
                                        <div class="section-body">
                                            <template
                                                    v-if="entityDetail.capacityCodes && entityDetail.capacityCodes.length">
                                                <div class="codes-container">{{ entityDetail.capacityCodes.join(', ') }}
                                                </div>
                                            </template>
                                            <template v-else>None</template>
                                        </div>
                                    </div>
                                    <div class="section">
                                        <div class="section-header">
                                            Owned Codes
                                        </div>
                                        <div class="section-body">
                                            <template v-if="entityDetail.ownedCodes && entityDetail.ownedCodes.length">
                                                <div class="codes-container">{{
                                                        entityDetail.ownedCodes.join(', ')
                                                    }}
                                                </div>
                                            </template>
                                            <template v-else>None</template>
                                        </div>
                                    </div>
                                    <div class="section">
                                        <div class="section-header">
                                            Traded Codes
                                        </div>
                                        <div class="section-body">
                                            <template
                                                    v-if="entityDetail.tradedCodes && entityDetail.tradedCodes.length">
                                                <div class="codes-container">{{
                                                        entityDetail.tradedCodes.join(', ')
                                                    }}
                                                </div>
                                            </template>
                                            <template v-else>None</template>
                                        </div>
                                    </div>
                                    <div class="section">
                                        <div class="section-header with-controls">
                                            <div class="header-text">
                                                Capacity (Linked Only)
                                            </div>
                                            <simple-dropdown :dropdown-arrow="true" class="more-info-dropdown"
                                                             :alignment="1" :click-dropdown-menu-to-hide="false"
                                                             @dropdownMenuShown="onAddCapacityDropdownShow"
                                                             ref="addCapacityDropdown"
                                            >
                                                <template v-slot:triggerButtonContent>
                                                    <button class="icon-button"><i class="gf gf-add"></i></button>
                                                </template>
                                                <template v-slot:dropdownMenu>
                                                    <div class="dropdown-content">
                                                        <div class="add-index-id-dropdown">
                                                            <div class="header">Add New Linked Capacity:</div>
                                                            <input type="text" placeholder="Input an index ID"
                                                                   ref="capacityIndexIdInputField"
                                                                   @keydown.enter="tryAddCapacityIndexId"
                                                            >
                                                            <button class="button-primary"
                                                                    @click="tryAddCapacityIndexId">
                                                                Add
                                                            </button>
                                                        </div>
                                                    </div>
                                                </template>
                                            </simple-dropdown>
                                        </div>
                                        <div class="section-body">
                                            <div class="list-items" v-if="eventData.capacity_index_ids.length">
                                                <capacity-row class="list-item"
                                                              v-for="(item) in eventData.capacity_index_ids"
                                                              :key="item"
                                                              :index-id="item"
                                                              @removeItem="tryRemoveCapacityIndexId"
                                                              ref="capacityRows"
                                                ></capacity-row>
                                            </div>
                                            <div v-else>None</div>
                                        </div>
                                    </div>
                                    <div class="section">
                                        <div class="section-header with-controls">
                                            <div class="header-text">
                                                Person Bio (Linked Only)
                                            </div>
                                            <simple-dropdown :dropdown-arrow="true" class="more-info-dropdown"
                                                             :alignment="1" :click-dropdown-menu-to-hide="false"
                                                             @dropdownMenuShown="onAddPersonBioDropdownShow"
                                                             ref="addPersonBioDropdown"
                                            >
                                                <template v-slot:triggerButtonContent>
                                                    <button class="icon-button"><i class="gf gf-add"></i></button>
                                                </template>
                                                <template v-slot:dropdownMenu>
                                                    <div class="dropdown-content">
                                                        <div class="add-index-id-dropdown">
                                                            <div class="header">Add New Linked Person Bio:</div>
                                                            <input type="text" placeholder="Input an index ID"
                                                                   ref="personBioIndexIdInputField"
                                                                   @keydown.enter="tryAddPersonBioIndexId"
                                                            >
                                                            <button class="button-primary"
                                                                    @click="tryAddPersonBioIndexId">
                                                                Add
                                                            </button>
                                                        </div>
                                                    </div>
                                                </template>
                                            </simple-dropdown>
                                        </div>
                                        <div class="section-body">
                                            <div class="list-items" v-if="eventData.person_bio_index_ids.length">
                                                <person-bio-row class="list-item"
                                                                v-for="(item) in eventData.person_bio_index_ids"
                                                                :key="item"
                                                                :index-id="item"
                                                                @removeItem="tryRemovePersonBioIndexId"
                                                                ref="personBioRows"
                                                ></person-bio-row>
                                            </div>
                                            <div v-else>None</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>The person "{{ eventData.gid }}" doesn't exist in AdminHK</div>
                    </template>
                </dynamic-display>
                <div class="text-right mt-3">
                    <button class="w-100" @click="goEntityFinderScene">Link to Another Person</button>
                </div>
            </div>
            <div v-show="eventData.gid === null" class="entity-finder-scene">
                <h1 class="mb-3">Link to a Person in AdminHK</h1>
                <div class="search-box-header">
                    <div class="header-text">Search for a Person</div>
                    <a class="new-person-button" href="#" @click.prevent="openWindowForNewPerson">New Person</a>
                </div>
                <div class="search-box-container">
                    <input type="text" @input="onEntitySearchFieldInput"
                           ref="searchField"
                           placeholder="Search by name, stock code, Gekko ID, etc"
                    >
                    <i class="gf gf-search search-icon"></i>
                </div>
                <div class="search-results-container" v-if="searchEntityManager.showResultsContainer">
                    <template v-if="searchEntityManager.isLoading">
                        <div class="search-state">Loading...</div>
                    </template>
                    <template v-else-if="searchEntityManager.showSuggestedItems">
                        <div class="search-state">
                            {{ searchEntityManager.suggestionItems.length }} Suggestion(s)
                        </div>
                        <div class="table-container">
                            <table class="light-table">
                                <thead>
                                <tr>
                                    <th class="column-action">
                                        <div class="content"></div>
                                    </th>
                                    <th>
                                        <div class="content">Name</div>
                                    </th>
                                    <th>
                                        <div class="content">Birthday</div>
                                    </th>
                                    <th>
                                        <div class="content">Gender</div>
                                    </th>
                                  <th>
                                    <div class="content">Capacity Codes</div>
                                  </th>
                                  <th>
                                    <div class="content">Owned Codes</div>
                                  </th>
                                  <th>
                                    <div class="content">Traded Codes</div>
                                  </th>
                                  <th>
                                    <div class="content">Other Names</div>
                                  </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(item,index) in searchEntityManager.suggestionItems" :key="index">
                                    <td class="column-action">
                                        <div class="content">
                                            <div class="mb-1">
                                                <button @click="selectEntity(item)">Select</button>
                                            </div>
                                            <div>
                                                <button @click="reviewPerson(item.gid)">Review</button>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="content">
                                            <div v-html="item.nameEn" class="text-nowrap"></div>
                                            <div v-html="item.nameCh" class="text-nowrap"></div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="content">{{ item.birthday }}</div>
                                    </td>
                                    <td>
                                        <div class="content">{{ item.gender }}</div>
                                    </td>
                                    <td>
                                        <div class="content">
                                            <div v-if="item.capacityCodes" class="codes-container"
                                                 :title="item.capacityCodes.join(', ')">
                                                <span class="code-item" v-for="(item,index) in item.capacityCodes"
                                                      :key="index">{{ item }}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="content">
                                            <div v-if="item.ownedCodes" class="codes-container"
                                                 :title="item.ownedCodes.join(', ')">
                                                <span class="code-item" v-for="(item,index) in item.ownedCodes"
                                                      :key="index">{{ item }}</span>
                                            </div>
                                        </div>
                                    </td>
                                  <td>
                                    <div class="content">
                                      <div v-if="item.tradedCodes" class="codes-container"
                                           :title="item.tradedCodes.join(', ')">
                                                <span class="code-item" v-for="(item,index) in item.tradedCodes"
                                                      :key="index">{{ item }}</span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="content">
                                      <div v-if="item.personOtherNames">
                                        <span v-text="item.personOtherNames.join(', ')"></span>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </template>
                    <template v-else-if="searchEntityManager.showEmptyIndicator">
                        <div class="search-state">No results found</div>
                    </template>
                    <template v-else-if="searchEntityManager.meetLoadingError">
                        <div class="search-state">An error occurred. Try again later.</div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    genRanHex,
    getAppropriateNoun,
    getDataPointInSuggestionItem,
    getReviewPersonLinkToAdminHK,
    tempIdProvider,
    userSettingsManager,
    workModeEdit,
    workModeRead
} from "@/utils";
import {Promise} from 'es6-promise-polyfill';
import {createPersonLink} from "@/config/constants";
import {getPersonBioData, getPersonCapacityData, getSuggestedEntities} from "@/apis";
import DynamicDisplay from "@/components/DynamicDisplay";
import CapacityRow from "@/components/CapacityRow";
import SimpleDropdown from "@/components/SimpleDropdown";
import PersonBioRow from "@/components/PersonBioRow";

const cardTypes = {
    capacity: 0,
    person_bio: 1,
}

export default {
    name: "DTEventForCU",
    components: {PersonBioRow, SimpleDropdown, CapacityRow, DynamicDisplay},
    props: {
        eventObject: Object,
        documentObject: Object,
    },
    data() {
        return {
            initialized: false,
            initializedPromise: null,
            initializedResolvers: [],
            searchEntityManager: {
                showResultsContainer: null,
                suggestionItems: null,
                currentlyLoadingKeywords: null,
                isLoading: null,
                meetLoadingError: null,
                showSuggestedItems: null,
                showEmptyIndicator: null,
            },
            adminHKRequestID: null,
            eventData: {
                gid: null,
                capacity_index_ids: [],
                person_bio_index_ids: [],
            },
            entityDetail: null,
        }
    },
    mounted() {
        this.initializedPromise = new Promise((resolve) => {
            this.initializedResolvers.push(resolve);
        });
        this.$nextTick(() => {
            this.initializeControls();
        })
        window.addEventListener('message', this.handleMessage);

        if (this.eventNewlyCreated) {
            this.goEntityFinderScene();
        }
    },
    destroyed() {
        window.removeEventListener('message', this.handleMessage);
    },
    computed: {
        fields() {
            return this.fieldsTemplate && this.fieldsTemplate['fields'] || [];
        },
        eventNewlyCreated() {
            return this.getEventId()[0] === ':';
        },
        workMode() {
            return userSettingsManager.getWorkMode();
        },
        inEditWorkMode() {
            return this.workMode === workModeEdit;
        },
        inReadWorkMode() {
            return this.workMode === workModeRead;
        },
        preloadComponent() {
            const {documentObject} = this;
            let gid = documentObject['company_gids'];
            if (gid && gid.length === 1) {
                gid = gid[0];
            } else {
                gid = null;
            }
            let {custom_data, sources} = documentObject;
            let preload = {
                capacity: {
                    content: {
                        Gekko_id_company: gid,
                        Stock_code: custom_data['stock_code'],
                        Link: sources.en,
                        Source: 'hkex-file'
                    }
                },
                person_bio: {
                    content: {
                        Gekko_id_company: gid,
                        Stock_code: custom_data['stock_code'],
                        Link: sources.en,
                        Source: 'hkex-file'
                    }
                }
            }
            return btoa(JSON.stringify(preload));
        }
    },
    watch: {
        workMode(newVal) {
            if (newVal === workModeEdit) {
                this.$nextTick(() => {
                    this.initializeControls();
                })
            }
        }
    },
    methods: {
        onLoadEnd(showingResults, results) {
            if (results && results.length) {
                this.entityDetail = this.transformSuggestionItem(results[0]);
            } else {
                this.entityDetail = null;
            }
        },
        initializeControls() {
            if (this.initialized) {
                return;
            }

            const {values} = this.eventObject;
            if (values && 'gid' in values) {
                this.resetForm(values);
            }

            this.initialized = true;
            this.initializedResolvers.forEach(r => {
                r();
            });
        },
        valueChanged() {
            if (!this.initialized) {
                return;
            }

            this.$emit('valueChanged');
        },
        getEventId() {
            return this.eventObject['event_id'];
        },
        getFormValues() {
            if (!this.initialized) {
                throw new Error('Not fully initialized!')
            }
            if (this.eventData.gid !== null) {
                return JSON.parse(JSON.stringify(this.eventData));
            }
            return null;
        },
        openWindowForNewPerson() {
            this.openWindowHelper(createPersonLink + '?preload=' + this.preloadComponent);
        },
        openWindowHelper(url) {
            this.moveAdminHKRequestID();
            return window.open(`${url}${url.indexOf('?') >= 0 ? '&' : '?'}clk_source=da2&req=${this.adminHKRequestID}`, '', 'width=1200,height=800,menubar=yes,location=no,resizable=yes,scrollbars=yes,status=yes')
        },
        onEntitySearchFieldInput() {
            this.trySearchEntities();
        },
        trySearchEntities() {
            const searchField = this.$refs.searchField;

            const value = searchField.value.trim();

            if (value === this.searchEntityManager.currentlyLoadingKeywords) {
                return;
            }

            if (!value) {
                this.hideSearchEntityResultsContainer();
                return;
            }

            if (this.searchEntityManager.showResultsContainer) {
                this.searchEntityManager.currentlyLoadingKeywords = value;
            } else {
                this.setSearchEntityManagerData(true, null, value, true, false, false, false)
            }

            getSuggestedEntities(value, 20, 'person', true).then(r => {
                if (this.searchEntityManager.currentlyLoadingKeywords !== value) {
                    return;
                }
                const data = this.transformSuggestionsData(r.data);
                this.setSearchEntityManagerData(true, data, null, false, false, data.length, !data.length);
            }).catch(err => {
                if (value !== this.searchEntityManager.currentlyLoadingKeywords) {
                    return;
                }
                this.setSearchEntityManagerData(true, null, null, false, true, false, false);
                this.handleServerSideError(err).catch(() => {

                })
            })
        },
        setSearchEntityManagerData(showResultsContainer, suggestionItems, currentlyLoadingKeywords, isLoading, meetLoadingError, showSuggestedItems, showEmptyIndicator) {
            this.searchEntityManager.showResultsContainer = showResultsContainer;
            this.searchEntityManager.suggestionItems = suggestionItems;
            this.searchEntityManager.currentlyLoadingKeywords = currentlyLoadingKeywords;
            this.searchEntityManager.isLoading = isLoading;
            this.searchEntityManager.meetLoadingError = meetLoadingError;
            this.searchEntityManager.showSuggestedItems = showSuggestedItems;
            this.searchEntityManager.showEmptyIndicator = showEmptyIndicator;
        },
        hideSearchEntityResultsContainer() {
            this.setSearchEntityManagerData(false, null, null, null, null, null, null);
        },
        transformSuggestionItem(item) {
            item = {
              _source: item,
            }
          let nameEn = getDataPointInSuggestionItem(item, 'Gekko_fullname');
          let nameCh = getDataPointInSuggestionItem(item, 'Gekko_ch');
          let birthday = getDataPointInSuggestionItem(item, 'Birthday');
          let gender = getDataPointInSuggestionItem(item, 'Gender');
          let capacityCodes = getDataPointInSuggestionItem(item, 'Stock_code', false);
          let ownedCodes = getDataPointInSuggestionItem(item, 'owned_codes', false);
          let tradedCodes = getDataPointInSuggestionItem(item, 'traded_codes', false);
          let gid = getDataPointInSuggestionItem(item, 'Gekko_id_person');
          let personOtherNames = getDataPointInSuggestionItem(item, 'person_other_names', false);

          capacityCodes && capacityCodes.sort();
          ownedCodes && ownedCodes.sort();
          tradedCodes && tradedCodes.sort();
          return {
            nameEn,
            nameCh,
            birthday,
            gender,
            capacityCodes,
            ownedCodes,
            tradedCodes,
            gid,
            personOtherNames,
          }
        },
        transformSuggestionsData(responseData) {
            const data = [];
            for (let item of responseData) {
                data.push(this.transformSuggestionItem(item));
            }
            return data;
        },
        selectEntity(item) {
            this.handleEventData(item.gid);
        },
        reviewPerson(gid, addPreload) {
            let url = getReviewPersonLinkToAdminHK(gid);
            if (addPreload) {
                url += '?preload=' + this.preloadComponent;
            }
            this.openWindowHelper(url);
        },
        handleMessage(event) {
            let data = event.data;
            if (data && data instanceof Object &&
                    data.action === 'da2link_done' &&
                    data['req'] === this.adminHKRequestID && (data = data['da2_table_changes_helper'])) {
                this.adminHKRequestID = null;
                this.handleEventData(data['person_id'], data['capacity_index_ids'], data['person_bio_index_ids']);
                event.source.close();
            }
        },
        moveAdminHKRequestID() {
            this.adminHKRequestID = tempIdProvider(genRanHex(32));
        },
        handleEventData(gid, capacity_index_ids, person_bio_index_ids) {
            if (gid === null) {
                this.eventData = {
                    gid: null,
                    capacity_index_ids: [],
                    person_bio_index_ids: []
                }
                this.valueChanged();
                return
            }

            gid = parseInt(gid);
            capacity_index_ids = capacity_index_ids || [];
            person_bio_index_ids = person_bio_index_ids || [];

            let addedCapacityLinks = 0, addedPersonBioLinks = 0;
            let isNewPerson = false;

            if (gid === this.eventData.gid) {
                // it's the same person, so simply update the index ids...
                capacity_index_ids.forEach(index_id => {
                    if (this.eventData.capacity_index_ids.indexOf(index_id) === -1) {
                        this.eventData.capacity_index_ids.push(index_id);
                        addedCapacityLinks++;
                    }
                })
                person_bio_index_ids.forEach(index_id => {
                    if (this.eventData.person_bio_index_ids.indexOf(index_id) === -1) {
                        this.eventData.person_bio_index_ids.push(index_id);
                        addedPersonBioLinks++;
                    }
                })
            } else {
                // it's a new person
                isNewPerson = true;
                this.eventData = {
                    gid: gid,
                    capacity_index_ids: capacity_index_ids,
                    person_bio_index_ids: person_bio_index_ids,
                }
                addedCapacityLinks = capacity_index_ids.length;
                addedPersonBioLinks = person_bio_index_ids.length;
            }

            this.notifyChanges(isNewPerson, addedCapacityLinks, addedPersonBioLinks);
            this.valueChanged();
        },
        notifyChanges(isNewPerson, addedCapacityLinks, addedPersonBioLinks) {
            function describeChange(change, topic) {
                let m;
                if (change > 0) {
                    m = 'added ';
                } else {
                    m = 'removed '
                }
                return m + Math.abs(change) + ' ' + getAppropriateNoun(topic, change);
            }

            let message = '';
            if (isNewPerson) {
                message += `Selected person "${this.eventData.gid}"`
                if (addedCapacityLinks || addedPersonBioLinks) {
                    message += ` with ${addedCapacityLinks} Capacity ${getAppropriateNoun('link', addedCapacityLinks)}, ${addedPersonBioLinks} Person Bio ${getAppropriateNoun('link', addedPersonBioLinks)}`
                }
            } else if (addedCapacityLinks || addedPersonBioLinks) {
                if (addedCapacityLinks) {
                    message += describeChange(addedCapacityLinks, 'Capacity link');
                }
                if (addedPersonBioLinks) {
                    if (message) {
                        message += ', '
                    }
                    message += describeChange(addedPersonBioLinks, 'Person Bio link');
                }
                message = message[0].toUpperCase() + message.substr(1);
            }
            if (message) {
                this.$toasted.show(message, {duration: 3000})
            }
        },
        goEntityFinderScene() {
            this.handleEventData(null);
            this.$nextTick(() => {
                this.$refs.searchField.focus();
            })
        },
        getLoadEntityApi() {
            return getSuggestedEntities.bind(null, this.eventData.gid, 1, undefined, true);
        },
        onAddCapacityDropdownShow() {
            this.onAddCardDropdownShow(cardTypes.capacity);
        },
        onAddCardDropdownShow(cardType) {
            this.$nextTick(() => {
                let target;
                switch (cardType) {
                    case cardTypes.capacity:
                        target = this.$refs.capacityIndexIdInputField;
                        break;
                    case cardTypes.person_bio:
                        target = this.$refs.personBioIndexIdInputField;
                        break;
                    default:
                        throw new Error('Invalid card type: ' + cardType)
                }
                target.value = '';
                setTimeout(() => {
                    target.focus();
                }, 0);
            })
        },
        tryAddCapacityIndexId() {
            this.tryAddCardIndexId(cardTypes.capacity);
        },
        tryAddCardIndexId(cardType) {
            let inputField, dropdown, index_ids, indexIdFinder, cardRowsKeyName;
            switch (cardType) {
                case cardTypes.capacity:
                    inputField = this.$refs.capacityIndexIdInputField;
                    dropdown = this.$refs.addCapacityDropdown;
                    index_ids = this.eventData.capacity_index_ids;
                    indexIdFinder = getPersonCapacityData;
                    cardRowsKeyName = 'capacityRows';
                    break;
                case cardTypes.person_bio:
                    inputField = this.$refs.personBioIndexIdInputField;
                    dropdown = this.$refs.addPersonBioDropdown;
                    index_ids = this.eventData.person_bio_index_ids;
                    indexIdFinder = getPersonBioData;
                    cardRowsKeyName = 'personBioRows';
                    break;
                default:
                    throw new Error('Invalid card type: ' + cardType);
            }
            const value = inputField.value.trim();
            if (!value) {
                inputField.focus();
                return
            }
            const number = parseInt(value);
            if (number.toString() !== value) {
                this.$toasted.show(`"${value}" doesn't seem like a valid Index ID!`, {duration: 3000})
                inputField.focus();
                inputField.selectionStart = 0;
                inputField.selectionEnd = value.length;
                return
            }
            if (index_ids.indexOf(number) >= 0) {
                this.$toasted.show(`${value} already linked!`, {duration: 3000})
                inputField.focus();
                inputField.selectionStart = 0;
                inputField.selectionEnd = value.length;
                return
            }
            let cont = true;
            indexIdFinder(value, this.eventData.gid).then(r => {
                const data = r.data;
                if (!data) {
                    cont = false;
                    this.$toasted.show(`Index ID "${value}" doesn't exist for the person in AdminHK!`, {duration: 3000})
                }
            }).always(() => {
                if (cont) {
                    index_ids.push(number);
                    dropdown.toggleDropdownMenu(false);
                    this.$nextTick(() => {
                        const cardRows = this.$refs[cardRowsKeyName];
                        for (let i = 0; i < cardRows.length; i++) {
                            if (cardRows[i].indexId === number) {
                                cardRows[i].focus();
                                break;
                            }
                        }
                    })
                    this.notifyChanges(false, cardType === cardTypes.capacity ? 1 : 0, cardType === cardTypes.person_bio ? 1 : 0);
                    this.valueChanged();
                }
            })
        },
        tryRemoveCapacityIndexId(indexId) {
            this.tryRemoveCardIndexId(cardTypes.capacity, indexId);
        },
        tryRemovePersonBioIndexId(indexId) {
            this.tryRemoveCardIndexId(cardTypes.person_bio, indexId);
        },
        tryRemoveCardIndexId(cardType, indexId) {
            let index_ids;
            switch (cardType) {
                case cardTypes.capacity:
                    index_ids = this.eventData.capacity_index_ids;
                    break;
                case cardTypes.person_bio:
                    index_ids = this.eventData.person_bio_index_ids;
                    break;
                default:
                    throw new Error('Invalid card type: ' + cardType);
            }
            index_ids.splice(index_ids.indexOf(indexId), 1);
            this.notifyChanges(false, cardType === cardTypes.capacity ? -1 : 0, cardType === cardTypes.person_bio ? -1 : 0);
            this.valueChanged();
        },
        tryAddPersonBioIndexId() {
            this.tryAddCardIndexId(cardTypes.person_bio);
        },
        onAddPersonBioDropdownShow() {
            this.onAddCardDropdownShow(cardTypes.person_bio)
        },
        resetForm(formData) {
            this.eventData = {
                gid: formData.gid || null,
                capacity_index_ids: [].concat(formData.capacity_index_ids || []),
                person_bio_index_ids: [].concat(formData.person_bio_index_ids || []),
            }
            this.valueChanged();
        },
    }
}
</script>
